import type { User } from '@/types/UserData';

export function gtmUserParams(user?: User | null): GtmEvents.Base {
  const { user: userData } = storeToRefs(useUserDataStore());

  const data = user || userData.value;

  if (!data) {
    return {};
  }

  return {
    first_name: data.first_name,
    last_name: data.last_name,
    user_id: data.id,
    email: data.email,
    phone: data.phone,
    dob: data.birth_date.replace(/-/g, ''),
    btag_id: data?.recommended_by,
  };
}
